var _defs, _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _circle;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgColorModeDark = function SvgColorModeDark(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dark-a,.dark-d{fill:none;}.dark-a{stroke:#787f98;stroke-miterlimit:10;}.dark-circle{fill:#787f98; opacity: 0}.dark-c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dark-a",
    transform: "translate(6.5 6.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "dark-c",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dark-d",
    cx: 5,
    cy: 5,
    r: 4.5
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "dark-a",
    y2: 5,
    transform: "translate(11.5)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "dark-a",
    y2: 5,
    transform: "translate(11.5 18)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "dark-a",
    x1: 5,
    transform: "translate(18 11.5)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "dark-a",
    x1: 5,
    transform: "translate(0 11.5)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "dark-a",
    x1: 2,
    y2: 2,
    transform: "translate(16.096 4.904)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "dark-a",
    x1: 2,
    y2: 2,
    transform: "translate(4.904 15.5)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "dark-a",
    x1: 2,
    y1: 2,
    transform: "translate(16.096 16.096)"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "dark-a",
    x1: 2,
    y1: 2,
    transform: "translate(4.904 4.904)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "dark-circle",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(8.5 8.5)"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColorModeDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/color-mode-dark.c41025a4.svg";
export { ForwardRef as ReactComponent };